export const ONLINES_PROJECT_INDEX = {
    1:
      "6ee1e54530f94f7780a5de98473a50b6",
    2:
      "b1e7ff644881488c9d90508feb43aaec",
    3:
      "1da8a8f928c847c185424d0799566fa2",
    4:
      "d095fa3d66ac466eac5ee8726cc73624",
    5:
      "bdb65705630b446bba6e8aa8e56a770b",
    6:
      "25d62d8eb0d24f049909cc039eabc6dc",
    7:
      "c0d68aba984d4eb79b2c398bf0b64ef1",
    8:
      "f333f38db48d4f49be966279882badaa",
    9:
      "78b3756c96f9447398d515ccf9cc4570",
    10:
      "4e6ce404cc294b6bbe2c85e10bf1b4e4",
    11:
      "59004c2e416c4a67a9d9db60edfa4e5e",
    12:
      "c8b400684d28485f913ad1cb0f0db25b",
    13:
      "789471b400e04d1e937169f86a9637b7",
    14:
      "2343708ca49f4e9e8f64991edb893e29",
    15:
      "4b0cfa65f2fb48d298e7fe0b07408b2d",
    16:
      "81efec2b492749f0a4b742d67812671f",
    17:
      "1de7210a0d0c4ee18ba27f4268f236ba",
    18:
      "9eee16ddba454c23a68432b554cc05d8",
    19:
      "d98e99fd878c4106aec7c84b2de73ddc",
    20:
      "ecac2ea4717843509d62ee5e4e70b220",
    21:
      "99150d626ec642d38b78378a5cee36a3",
    22:
      "7d411e61c69b4182b100b4025560f4d4",
    23:
      "a718c69553f34d31902708ccc7d2d4a5",
    24:
      "6c1835fd3d8d4921a1359025d154d22f",
    25:
      "158ead9efa1b4484bcfe1d1b720dadf9",
    26:
      "f971516688564bcf928fd35147b8bc5d",
    27:
      "957244c386d647ab88a4f50681c4d939",
    28:
      "1740a69fe35c4e9b83a4f3b4355ca011",
    29:
      "7cb092aa11584529aae1040bd126f1f8",
    30:
      "bed506e4c8754ba99d49d92098aeff59",
    31:
      "2f31b48203744d33a6951743e3a01c4a",
    32:
      "8fd94fa37ea04698a5e398a9e0df2c7d",
    33:
      "0919be6a05cb44fd9ad506b2a8ec0f84",
    34:
      "34fdba9e6090499fabc74bce0d14e098",
    35:
      "3c769f84d5504de6a716880b1828d0c7",
    36:
      "66ec15dd34fd4df59c936b17ad002038",
    37:
      "3c079419eb934e69bd616ff4564b6ac5",
    38:
      "1a32fc89c81348dcb1f2a864ea0b170a",
    39:
      "b4d486361af547b3be20259db823385c",
    40:
      "be196307d2914e85a67a25e11c4e0b10",
    41:
      "8efb8cc5066a44cd87066aba034cb864",
    42:
      "24bd5d27b18b48da86fd384e56768220",
    43:
      "9d2af64f6d624b60bf0e1d0d27c5e4a9",
    // 44:
    //   "90e08c46f80a4d1c943e79cf0c0bee1b",
    // 45:
    //   "4fef355b7ed8421b989c00eefc53602d",
    46:
      "974b5cfc690a404fbc4bc801d283b6af",
    47:
      "bcac028a01bb49df9e8e44b3b8c18f74",
    48:
      "a63c669a51984e4a9647be92668f2c5f",
    49:
      "e68ed2ce24294dd4ae037f5f45d773b1",
    50:
      "e6ae1dc6f9884a70bfe964c5fc6cfaba",
    51:
      "bcccee6eb19f4243872825d50cae1486",
    52:
      "cdc0d6bfd41644908db35d43835844a2",
    53:
      "d9da04ec4bd34350a8a603b1d2d6d722",
    54:
      "422e3d5b569941098bbc18ef103d2cff",
    55:
      "d5d007d27ecd4643822d0e0a5292d52f",
    56:
      "4811c9c857bb4b59a5de941b26e4baaa",
    57:
      "b6c8aa6605124cf9bef30e87a93e5819",
    58:
      "3ac9ad49c9d04a78b2f0cac2ad36f647",
    59:
      "5ea19804d1f14f6887787c57791d02ed",
    60:
      "56311823a38540bcb03d8b1ae966d7da",
    61:
      "c6b3472238bb411dac19561afb28d57b",
    62:
      "e90e9f0961b44dbca268e0ceb4070a6f",
    63:
      "758605d8281b49678ff33bc5a8555739",
    64:
      "c413e4915b0b4cb2925f7b34d607aa05",
    65:
      "70c13a513926454cab68cb4b2cd3be82",
    66:
      "8ba43ad663f548308b3435bf4a054894",
    67:
      "54d3fcf36eef446bb364bad479f5f170",
    68:
      "b7961d8966b24d60bd8de471737625e3",
    69:
      "2134550deefe449a838b1c89b1c66e58",
    70:
      "e71d463b590b4e07a4ca3cad0857d72d",
  }
  
  export const ONLINES_PROJECT_ARRAY = [
    'b3eed99da0984d89abe6e38c9dd7071b',
    'b1e7ff644881488c9d90508feb43aaec',
    '52a5a72ddb5c4010ad154e9bf2d371c1',
    '5135677c840a4b8f9526394a3cafdac4',
    '444ff9724a3d4b9d9448059710cc030a',
    '63d2a338d14a446b86d52fe435c3003f',
    '1620c3f8edcc42f5b1e21ce69c02f23f',
    'f7c6633b2c204a209c09a8c48376c122',
    ...Object.values(ONLINES_PROJECT_INDEX)
  ];
  
  export const ONLINES_PROJECT_ORDER_INDEX = ONLINES_PROJECT_ARRAY.reduce((result, item, index) => {
    return {
      ...result,
      [item]: index,
    }
  }, {})

  export const OLD_HSE_SORTING_IDX = {
    "date": 14,
    "popular": 15
  }export const ONLINES_PROJECT_INDEX = {
    1:
      "6ee1e54530f94f7780a5de98473a50b6",
    2:
      "b1e7ff644881488c9d90508feb43aaec",
    3:
      "1da8a8f928c847c185424d0799566fa2",
    4:
      "d095fa3d66ac466eac5ee8726cc73624",
    5:
      "bdb65705630b446bba6e8aa8e56a770b",
    6:
      "25d62d8eb0d24f049909cc039eabc6dc",
    7:
      "c0d68aba984d4eb79b2c398bf0b64ef1",
    8:
      "f333f38db48d4f49be966279882badaa",
    9:
      "78b3756c96f9447398d515ccf9cc4570",
    10:
      "4e6ce404cc294b6bbe2c85e10bf1b4e4",
    11:
      "59004c2e416c4a67a9d9db60edfa4e5e",
    12:
      "c8b400684d28485f913ad1cb0f0db25b",
    13:
      "789471b400e04d1e937169f86a9637b7",
    14:
      "2343708ca49f4e9e8f64991edb893e29",
    15:
      "4b0cfa65f2fb48d298e7fe0b07408b2d",
    16:
      "81efec2b492749f0a4b742d67812671f",
    17:
      "1de7210a0d0c4ee18ba27f4268f236ba",
    18:
      "9eee16ddba454c23a68432b554cc05d8",
    19:
      "d98e99fd878c4106aec7c84b2de73ddc",
    20:
      "ecac2ea4717843509d62ee5e4e70b220",
    21:
      "99150d626ec642d38b78378a5cee36a3",
    22:
      "7d411e61c69b4182b100b4025560f4d4",
    23:
      "a718c69553f34d31902708ccc7d2d4a5",
    24:
      "6c1835fd3d8d4921a1359025d154d22f",
    25:
      "158ead9efa1b4484bcfe1d1b720dadf9",
    26:
      "f971516688564bcf928fd35147b8bc5d",
    27:
      "957244c386d647ab88a4f50681c4d939",
    28:
      "1740a69fe35c4e9b83a4f3b4355ca011",
    29:
      "7cb092aa11584529aae1040bd126f1f8",
    30:
      "bed506e4c8754ba99d49d92098aeff59",
    31:
      "2f31b48203744d33a6951743e3a01c4a",
    32:
      "8fd94fa37ea04698a5e398a9e0df2c7d",
    33:
      "0919be6a05cb44fd9ad506b2a8ec0f84",
    34:
      "34fdba9e6090499fabc74bce0d14e098",
    35:
      "3c769f84d5504de6a716880b1828d0c7",
    36:
      "66ec15dd34fd4df59c936b17ad002038",
    37:
      "3c079419eb934e69bd616ff4564b6ac5",
    38:
      "1a32fc89c81348dcb1f2a864ea0b170a",
    39:
      "b4d486361af547b3be20259db823385c",
    40:
      "be196307d2914e85a67a25e11c4e0b10",
    41:
      "8efb8cc5066a44cd87066aba034cb864",
    42:
      "24bd5d27b18b48da86fd384e56768220",
    43:
      "9d2af64f6d624b60bf0e1d0d27c5e4a9",
    // 44:
    //   "90e08c46f80a4d1c943e79cf0c0bee1b",
    // 45:
    //   "4fef355b7ed8421b989c00eefc53602d",
    46:
      "974b5cfc690a404fbc4bc801d283b6af",
    47:
      "bcac028a01bb49df9e8e44b3b8c18f74",
    48:
      "a63c669a51984e4a9647be92668f2c5f",
    49:
      "e68ed2ce24294dd4ae037f5f45d773b1",
    50:
      "e6ae1dc6f9884a70bfe964c5fc6cfaba",
    51:
      "bcccee6eb19f4243872825d50cae1486",
    52:
      "cdc0d6bfd41644908db35d43835844a2",
    53:
      "d9da04ec4bd34350a8a603b1d2d6d722",
    54:
      "422e3d5b569941098bbc18ef103d2cff",
    55:
      "d5d007d27ecd4643822d0e0a5292d52f",
    56:
      "4811c9c857bb4b59a5de941b26e4baaa",
    57:
      "b6c8aa6605124cf9bef30e87a93e5819",
    58:
      "3ac9ad49c9d04a78b2f0cac2ad36f647",
    59:
      "5ea19804d1f14f6887787c57791d02ed",
    60:
      "56311823a38540bcb03d8b1ae966d7da",
    61:
      "c6b3472238bb411dac19561afb28d57b",
    62:
      "e90e9f0961b44dbca268e0ceb4070a6f",
    63:
      "758605d8281b49678ff33bc5a8555739",
    64:
      "c413e4915b0b4cb2925f7b34d607aa05",
    65:
      "70c13a513926454cab68cb4b2cd3be82",
    66:
      "8ba43ad663f548308b3435bf4a054894",
    67:
      "54d3fcf36eef446bb364bad479f5f170",
    68:
      "b7961d8966b24d60bd8de471737625e3",
    69:
      "2134550deefe449a838b1c89b1c66e58",
    70:
      "e71d463b590b4e07a4ca3cad0857d72d",
  }
  
  export const ONLINES_PROJECT_ARRAY = [
    'b3eed99da0984d89abe6e38c9dd7071b',
    'b1e7ff644881488c9d90508feb43aaec',
    '52a5a72ddb5c4010ad154e9bf2d371c1',
    '5135677c840a4b8f9526394a3cafdac4',
    '444ff9724a3d4b9d9448059710cc030a',
    '63d2a338d14a446b86d52fe435c3003f',
    '1620c3f8edcc42f5b1e21ce69c02f23f',
    'f7c6633b2c204a209c09a8c48376c122',
    ...Object.values(ONLINES_PROJECT_INDEX)
  ];
  
  export const ONLINES_PROJECT_ORDER_INDEX = ONLINES_PROJECT_ARRAY.reduce((result, item, index) => {
    return {
      ...result,
      [item]: index,
    }
  }, {})

  export const OLD_HSE_SORTING_IDX = {
    "date": 14,
    "popular": 15
  }